import { BaseDto } from '../../core';
import { FileAttachmentDto } from '../../dto';

export class InquiryReplyCreateDto extends BaseDto<InquiryReplyCreateDto> {
  contents: string;
  attachments?: FileAttachmentDto[];
}
